import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import './styles/global.css';
import './styles/responsive.css';

import Navbar     from './components/Navbar';
import Footer     from './components/Footer';

import Home       from './pages/Home';
import About      from './pages/About';
import Services   from './pages/Services';
import Industries from './pages/Industries';
import Projects   from './pages/Projects';
import Contact    from './pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <main style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/"           element={<Home />}       />
          <Route path="/about"      element={<About />}      />
          <Route path="/services"   element={<Services />}   />
          <Route path="/industries" element={<Industries />} />
          <Route path="/projects"   element={<Projects />}   />
          <Route path="/contact"    element={<Contact />}    />
          <Route path="*"           element={<Home />}       />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
